import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** ΔP = P_lab − P_hood — lab envelope + hood with pressure taps to manometer. */
export function DiagramFumehoodPressureDifferential() {
  // Lab boundary
  const lx = 28, ly = 28, lw = 300, lh = 200;
  // Hood inside
  const hx = 135, hy = 70, hw = 140, hh = 140;

  return (
    <DiagramCanvas>
      {/* Lab room */}
      <Rect x={lx} y={ly} width={lw} height={lh} fill="rgba(122,170,187,0.05)" stroke={DT.dim} strokeWidth="1" strokeDasharray="6,4" />
      <SvgText x={60} y={46} fill={DT.leader} fontSize="9" fontFamily={DT.mono} fontWeight="700">LAB (P_lab)</SvgText>

      {/* Hood body */}
      <Rect x={hx} y={hy} width={hw} height={hh} fill="rgba(255,107,26,0.08)" stroke={DT.stroke} strokeWidth="1.6" />
      <SvgText x={hx + hw / 2} y={hy + 16} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">HOOD (P_hood)</SvgText>
      {/* Hood sash + face */}
      <Line x1={hx} y1={hy + 40} x2={hx + hw} y2={hy + 40} stroke={DT.stroke} strokeWidth="2.5" />
      <Rect x={hx} y={hy + 40} width={hw} height={hh - 40} fill="rgba(255,107,26,0.1)" stroke={DT.varColor} strokeWidth="1.2" strokeDasharray="4,3" />

      {/* Exhaust stack up */}
      <Rect x={hx + hw / 2 - 12} y={40} width={24} height={hy - 40} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.2" />
      <Polygon points={`${hx + hw / 2 - 6},45 ${hx + hw / 2},39 ${hx + hw / 2 + 6},45`} fill={DT.arrow} />

      {/* Capture inflow arrows at face */}
      {[hx + 30, hx + 70, hx + 110].map((x, i) => (
        <G key={i}>
          <Line x1={x} y1={hy + hh + 18} x2={x} y2={hy + hh + 2} stroke={DT.arrow} strokeWidth="1.4" />
          <Polygon points={`${x},${hy + hh + 2} ${x - 4},${hy + hh + 8} ${x + 4},${hy + hh + 8}`} fill={DT.arrow} />
        </G>
      ))}

      {/* Pressure tap lines */}
      {/* Lab tap (upper-left) */}
      <Line x1={55} y1={80} x2={55} y2={160} stroke={DT.leader} strokeWidth="1" strokeDasharray="3,2" />
      <Circle cx={55} cy={80} r={3} fill={DT.leader} />
      {/* Hood tap (inside hood, upper) */}
      <Line x1={hx + 14} y1={hy + 14} x2={95} y2={160} stroke={DT.varColor} strokeWidth="1" strokeDasharray="3,2" />
      <Circle cx={hx + 14} cy={hy + 14} r={3} fill={DT.varColor} />

      {/* Differential manometer at bottom-left */}
      <Rect x={38} y={150} width={70} height={50} rx="4" fill={DT.fill} stroke={DT.varColor} strokeWidth="1.4" />
      <SvgText x={73} y={164} fill={DT.varColor} fontSize="8" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">ΔP gauge</SvgText>
      {/* U-tube */}
      <Path d={`M55,170 L55,192 Q55,196 59,196 L87,196 Q91,196 91,192 L91,170`} fill="none" stroke={DT.stroke} strokeWidth="1.2" />
      <Path d={`M55,184 L55,192 Q55,196 59,196 L73,196 L73,180 Z`} fill="#FF6B1A" opacity={0.6} />
      {/* + / − labels */}
      <SvgText x={55} y={166} fill={DT.leader} fontSize="8" fontFamily={DT.mono} textAnchor="middle">(+)</SvgText>
      <SvgText x={91} y={166} fill={DT.varColor} fontSize="8" fontFamily={DT.mono} textAnchor="middle">(−)</SvgText>

      {/* Pressure sign indicators */}
      <Circle cx={lx + 30} cy={lh - 10} r={10} fill={DT.fill} stroke={DT.leader} strokeWidth="1.2" />
      <SvgText x={lx + 30} y={lh - 6} fill={DT.leader} fontSize="14" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">+</SvgText>
      <Circle cx={hx + hw - 20} cy={hy + 34} r={10} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.2" />
      <SvgText x={hx + hw - 20} y={hy + 40} fill={DT.varColor} fontSize="16" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">−</SvgText>

      {/* Labels */}
      <LeaderLine x1={55} y1={80} x2={30} y2={60} varName="P_lab" desc="room static" anchor="start" />
      <LeaderLine x1={hx + 14} y1={hy + 14} x2={320} y2={55} varName="P_hood" desc="interior static" anchor="end" />
      <LeaderLine x1={73} y1={200} x2={175} y2={240} varName="ΔP" desc="P_lab − P_hood" anchor="middle" />

      <FormulaTag formula="ΔP = P_lab − P_hood > 0   (hood is negative w.r.t. lab)" />
    </DiagramCanvas>
  );
}
